/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ClearIndicator as CompiledClearIndicator, clearIndicatorCSS as compiledClearIndicatorCSS, DropdownIndicator as CompiledDropdownIndicator, dropdownIndicatorCSS as compiledDropdownIndicatorCSS, LoadingIndicator as CompiledLoadingIndicator, loadingIndicatorCSS as compiledLoadingIndicatorCSS } from '../compiled/components/indicators';
import { ClearIndicator as EmotionClearIndicator, clearIndicatorCSS as emotionClearIndicatorCSS, DropdownIndicator as EmotionDropdownIndicator, dropdownIndicatorCSS as emotionDropdownIndicatorCSS, LoadingIndicator as EmotionLoadingIndicator, loadingIndicatorCSS as emotionLoadingIndicatorCSS } from '../emotion/components/indicators';

// ==============================
// Dropdown & Clear Buttons
// ==============================

export var dropdownIndicatorCSS = function dropdownIndicatorCSS(props) {
  return fg('compiled-react-select') ? compiledDropdownIndicatorCSS() : emotionDropdownIndicatorCSS(props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var DropdownIndicator = function DropdownIndicator(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledDropdownIndicator, props) : /*#__PURE__*/React.createElement(EmotionDropdownIndicator, props);
};
export var clearIndicatorCSS = function clearIndicatorCSS(props) {
  return fg('compiled-react-select') ? compiledClearIndicatorCSS() : emotionClearIndicatorCSS(props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var ClearIndicator = function ClearIndicator(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledClearIndicator, props) : /*#__PURE__*/React.createElement(EmotionClearIndicator, props);
};

// ==============================
// Loading
// ==============================

export var loadingIndicatorCSS = function loadingIndicatorCSS(props) {
  return fg('compiled-react-select') ? compiledLoadingIndicatorCSS() : emotionLoadingIndicatorCSS(props);
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var LoadingIndicator = function LoadingIndicator(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledLoadingIndicator, props) : /*#__PURE__*/React.createElement(EmotionLoadingIndicator, props);
};